import React from "react";
import classes from "./TopHeader.module.scss";
import { useNavigate } from "react-router-dom";

type MenuUrl =
  | "/top"
  | "/misa-top"
  | "/diagnosis-list"
  | "/quiz"
  | "/point";
type Menu = { title: string; url: MenuUrl };
const menuList: Menu[] = [
  {
    title: "TOP",
    url: "/top",
  },
  {
    title: "MISA",
    url: "/misa-top",
  },
  {
    title: "診断",
    url: "/diagnosis-list",
  },
  {
    title: "○×クイズ",
    url: "/quiz",
  },
  {
    title: "ポイント",
    url: "/point",
  },
];

type Props = {
  currentMenuUrl: MenuUrl;
};

const TopHeader = (props: Props) => {
  const navigate = useNavigate();
  const getStyle = (menu: Menu) => {
    if (props.currentMenuUrl === menu.url) {
      return {
        background: "#008E7E",
        color: "#FFF",
      };
    }
    return {
      color: "#008E7E",
    };
  };

  return (
    <>
      <div className={classes.container}>
        {menuList.map((m) => {
          return (
            <div
              className={classes.menu}
              style={getStyle(m)}
              key={m.url}
              onClick={() => navigate(m.url)}
            >
              {m.title}
            </div>
          );
        })}
      </div>
    </>
  );
};

export default TopHeader;
